import dynamic from 'next/dynamic';

const ChatAudioRecorderComponent = dynamic(() => import('./ChatAudioRecorderComponent'), {
  ssr: false,
});

export const ChatAudioRecorder = ChatAudioRecorderComponent;
